import { RAG } from 'features/dashboard/charts/scoreColour'
import { remedialsViewUrl } from 'features/actions/workspace/remedialsQuery'

export const SHOW_REMEDIALS_KEY = 'calendarShowRemedials'
export const LEVELS = ['critical', 'high', 'medium', 'low']
export const REMEDIAL_LEGEND = LEVELS.map(level => ({ level, color: RAG[level].fg, label: `Remedial due: ${level.charAt(0).toUpperCase()}${level.slice(1)}` }))

export const calendarWindow = month => ({
  from: month.clone().startOf('month').startOf('week').format('YYYY-MM-DD'),
  to: month.clone().endOf('month').endOf('week').format('YYYY-MM-DD'),
})

export const indexByDate = byDate => (byDate || []).reduce((map, row) => {
  if (row?.date) map[String(row.date).slice(0, 10)] = row
  return map
}, {})

export const dayBadge = row => {
  if (!row || !row.total) return null
  const level = LEVELS.find(l => (row[l] || 0) > 0) || 'low'
  const parts = LEVELS.filter(l => (row[l] || 0) > 0).map(l => `${row[l]} ${l}`)
  return {
    count: row.total,
    level,
    color: RAG[level].fg,
    label: `${row.total} remedial${row.total === 1 ? '' : 's'}`,
    title: `Remedials due with no task yet: ${parts.join(', ')}. The colour shows the most serious one.`,
  }
}

export const itemsForDay = (items, day) => (items || []).filter(item => item.dueDate === day)

export const readShowRemedials = () => {
  try {
    return window.localStorage.getItem(SHOW_REMEDIALS_KEY) !== '0'
  } catch {
    return true
  }
}

export const writeShowRemedials = show => {
  try {
    window.localStorage.setItem(SHOW_REMEDIALS_KEY, show ? '1' : '0')
    return true
  } catch {
    return false
  }
}

export const seeAllUrl = ({ from, to, bp }) => remedialsViewUrl({}, 'needs_decision', { dueFrom: from, dueTo: to, bp })

export const forMonth = (feed, monthKey) => ({
  items: (feed?.items || []).filter(item => String(item.dueDate || '').startsWith(monthKey)),
  total: (feed?.byDate || []).filter(row => String(row.date || '').startsWith(monthKey)).reduce((sum, row) => sum + (row.total || 0), 0),
})
